export default __webpack_public_path__ + "static/media/content.19ff5041.svg";